import { render, staticRenderFns } from "./AccessLogs.vue?vue&type=template&id=a44ee264&scoped=true"
import script from "./AccessLogs.vue?vue&type=script&lang=ts"
export * from "./AccessLogs.vue?vue&type=script&lang=ts"
import style0 from "./AccessLogs.vue?vue&type=style&index=0&id=a44ee264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44ee264",
  null
  
)

export default component.exports